import { HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import {
  Actions,
  createEffect,
  ofType
} from "@ngrx/effects";
import { select, Store } from "@ngrx/store";
import {
  of
} from "rxjs";
import {
  catchError,
  exhaustMap,
  filter,
  map,
  withLatestFrom,
} from "rxjs/operators";
import { IBrandDetails } from "../../domain/brand.model";
import { getBrandDetails } from "../global/global.selectors";
import { NotificationsService } from "../../service/notifications.service";
import * as action from "./notifications.action";
import { NotificationCounters, NotificationsCount } from "./notifications.model";

@Injectable()
export class NotificationsEffect {

  setNotificationsCount$ = createEffect(() => this.actions$.pipe(
    ofType<action.NotificationsActions>(action.NotificationsActionTypes.SetNotificationsCount),
    exhaustMap(() =>
      this.notificationsService.fetchNotificationCount().pipe(
        map((data: NotificationsCount) => {
          return new action.SetNotificationsCountSuccess(data)
        }),
        catchError((err: HttpErrorResponse) => of(new action.SetNotificationsCountFault(err.message)))
      )
    )
  ));

  markAllReadNotifications$ = createEffect(() => this.actions$.pipe(
    ofType<action.NotificationsActions>(action.NotificationsActionTypes.MarkAllReadNotifications),
    exhaustMap(() =>
      this.notificationsService.markAllReadNotifications().pipe(
        map((res: any) => {
          if (res) {
            // const data = {
            //   pendingConnectionCount: 0,
            //   unreadNotificationCount: 0,
            //   unreadMessageCount: 0,
            //   sentConnectionCount: 0,
            //   pendingAcceptanceMentorHoursCount: 0,
            // pendingDocumentsUploadCount: 0,
            // pendingProgramFormSubmissionCount:0

            // }
            return new action.SetNotificationsCount()
          }
        }),
        catchError((err: HttpErrorResponse) => of(new action.MarkAllReadNotificationsFault(err.message)))
      )
    )
  ));

  // SAN-1428 — every existing count refresh (30 s poll, socket fetch-count,
  // mark-all-read) also refreshes the notification centre counters, so no
  // trigger needs wiring twice. Flag off → never called (the routes 403).
  fetchNotificationCounters$ = createEffect(() => this.actions$.pipe(
    ofType<action.NotificationsActions>(
      action.NotificationsActionTypes.SetNotificationsCount,
      action.NotificationsActionTypes.FetchNotificationCounters
    ),
    withLatestFrom(this.store.pipe(select(getBrandDetails))),
    filter(([, brandDetails]: [action.NotificationsActions, Partial<IBrandDetails>]) =>
      brandDetails?.features?.notification_centre_enabled === true),
    exhaustMap(() =>
      this.notificationsService.getCounters().pipe(
        map((data: NotificationCounters) => new action.FetchNotificationCountersSuccess(data)),
        catchError((err: HttpErrorResponse) => of(new action.FetchNotificationCountersFault(err.message)))
      )
    )
  ));

  constructor(private actions$: Actions, private notificationsService: NotificationsService, private store: Store<any>) {
  }
}
